/** @var { TelegramState } */
const STATE = {
    data: null,
    isLoggedInToTelegram: false,
};

export default STATE;
